<template>
    <div id="dashboard-page">
        <b-card>
            <b-row class="border-bottom mb-1">
                <b-col md="6">
                    <h3>{{$route.name}}</h3>
                    <b-breadcrumb>
                        <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                        <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                    </b-breadcrumb>
                </b-col>
                <b-col md="6 mt-3 float-right">
                    <b-button variant="primary" class="float-right btn-custom" :to="'vehicle/create'"><font-awesome-icon icon="plus"/></b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="9">
                    <b-row class="mt-3 mb-3">
                        <b-col md="3">
                            <b-form-input :placeholder="'Search by merk'" v-model="tableFilter.merk" customQueryParamName="search" />
                        </b-col>
                        <b-col md="3">
                            <b-form-input :placeholder="'Search by plate'" v-model="tableFilter.plate" customQueryParamName="search" />
                        </b-col>
                        <b-col md="3">
                            <b-form-select v-model="tableFilter.category" :options="categoryList" />
                        </b-col>
                        <b-col md="3">
                            <b-form-select v-model="tableFilter.branch" :options="branchList" />
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="2 mt-3">
                    <b-button variant="primary" class="btn-back float-left btn-custom" @click="doFilter"><font-awesome-icon icon="search"/></b-button>
                </b-col>
            </b-row>
            <paginated-table ref="dataTable" :can-edit="true" :can-delete="true" :can-approve="false" :can-reject="false" :data-url="apiUrl.vehicle" :data-key="dataKey" :data-columns="columns" :data-params="['merk', 'plate', 'category', 'branch_uuid']">
            </paginated-table>
        </b-card>
    </div>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    export default {
        name: 'vehicle',
        components: {
            PaginatedTable
        },
        data () {
            return {
                dataKey: 'vehicles',
                apiUrl: {
                    vehicle: window.AppConfig.apiUrl + 'vehicle'
                },
                columns: [
                    {
                        key: 'plate',
                        sortable: true
                    }, {
                        key: 'merk',
                        sortable: true
                    }, {
                        key: 'model',
                        sortable: true
                    }, {
                        key: 'category',
                        sortable: true
                    }, {
                        key: 'branch',
                        sortable: true
                    }, {
                        key: 'transmission',
                        sortable: true
                    }, {
                        key: 'color',
                        sortable: true
                    }, {
                        key: 'statusVehicle',
                        label: 'Status',
                        sortable: true
                    }, {
                        key: 'actions',
                        label: '',
                        sortable: false
                    }
                ],
                tableFilter: {
                    branch_uuid: this.$route.query.branch_uuid,
                    branch: null,
                    category_uuid: this.$route.query.category_uuid,
                    category: null,
                    merk: this.$route.query.merk,
                    plate: this.$route.query.plate
                },
                branchList: [
                    {
                        value: null,
                        text: 'All branch'
                    }
                ],
                categoryList: [
                    {
                        value: null,
                        text: 'All category'
                    }
                ]
            }
        },
        mounted () {
            this.getBranch()
            this.getCategory()
        },
        methods: {
            doFilter () {
                this.tableFilter.plate = this.tableFilter.plate
                this.tableFilter.merk = this.tableFilter.merk
                this.tableFilter.branch_uuid = this.tableFilter.branch
                this.tableFilter.category_uuid = this.tableFilter.category
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getCategory () {
                this.$http.get(window.AppConfig.apiUrl + 'vehicle-category?limit=10000').then(resp => {
                    resp.data._embedded.vehicleCategory.forEach(data => {
                        this.categoryList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getBranch () {
                this.$http.get(window.AppConfig.apiUrl + 'branch?limit=10000').then(resp => {
                    resp.data._embedded.branch.forEach(data => {
                        this.branchList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD hh:mm a')
                } else {
                    return '-'
                }
            },
            getStatusColor (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'danger'
                    // eslint-disable-next-line no-unreachable
                    break
                case 1:
                    return 'success'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            },
            getStatusName (val) {
                switch (parseInt(val)) {
                case 0:
                    return 'Not Available'
                    // eslint-disable-next-line no-unreachable
                    break
                case 1:
                    return 'Available'
                    // eslint-disable-next-line no-unreachable
                    break
                }
            }
        }
    }
</script>